import { Broker, NestedAutocompleteAddress } from '@habity/types';

/**
 * Check if a broker is a shark tank (fallback) broker
 * The database query sets result_type = 'fallback' for shark tank brokers
 */
export const isSharkTankBroker = (broker: Partial<Broker> | null): boolean => {
  if (!broker) return false;
  return (broker as any)?.result_type === 'fallback';
};

/**
 * Get display broker - replaces shark tank broker with default info
 */
export const getDisplayBroker = (
  broker: Partial<Broker> | null,
  selectedAddress: NestedAutocompleteAddress | null
): Partial<Broker> | null => {
  if (!broker) return broker;

  // If it's a shark tank broker, replace with default info
  if (isSharkTankBroker(broker)) {
    return {
      id: 0,
      name: selectedAddress?.city || 'ditt område',
      email: 'mail@erikolsson.se',
      phone: '0771-551 000',
      avatar_url: '/eo/images/eo-shark-tank-broker.webp',
      title: '',
    } as Partial<Broker>;
  }

  // Otherwise return the original broker
  return broker;
};

/**
 * Get display title for shark tank broker
 */
export const getSharkTankBrokerTitle = (
  broker: Partial<Broker> | null,
  selectedAddress: NestedAutocompleteAddress | null,
  defaultTitle: string
): string => {
  if (isSharkTankBroker(broker) && selectedAddress?.city) {
    return 'Du matchas med lokala mäklare i';
  }
  return defaultTitle;
};
